import * as React from 'react';
import { EmployeeBanner } from '../../../components/EmployeeBanner';
import { MessageSentFooterContainer } from '../../QuestionFooterContainer/containers/MessageSentFooterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export var EmployeeBannerContainer = function EmployeeBannerContainer() {
  return /*#__PURE__*/_jsx(EmployeeBanner, {
    footer: /*#__PURE__*/_jsx(MessageSentFooterContainer, {})
  });
};